/*
 * @Date: 2022-10-20 10:05:20
 * @LastEditors: guantingting
 * @LastEditTime: 2024-09-05 10:33:57
 */
export default [
    {
        path: '/rent/v2/c2c/tweeter',
        name: 'tweeter',
        component: () => import('@/pages/c2c/tweeter'),
        meta: { title: '房车推客', requireAuth: true },
    },
    {
        path: '/rent/v2/c2c/income',
        name: 'c2cIncome',
        component: () => import('@/pages/c2c/income'),
        meta: { title: '收益明细', requireAuth: true },
    },
    {
        path: '/rent/v2/c2c/record',
        name: 'c2cRecord',
        component: () => import('@/pages/c2c/record'),
        meta: { title: '提现记录', requireAuth: true },
    },
    {
        path: '/rent/v2/c2c/guide',
        name: 'c2cGuide',
        component: () => import('@/pages/c2c/guide'),
        meta: { title: '新手指南', requireAuth: true },
    },
    {
        path: '/rent/v2/c2c/rewardRules',
        name: 'rewardRules',
        component: () => import('@/pages/c2c/rewardRules'),
        meta: { title: '奖励规则', requireAuth: true },
    },
    {
        path: '/rent/v2/c2c/commonProblem',
        name: 'commonProblem',
        component: () => import('@/pages/c2c/commonProblem'),
        meta: { title: '常见问题', requireAuth: true },
    },
    {
        path: '/rent/v2/c2c/feedback',
        name: 'c2cFeedback',
        component: () => import('@/pages/c2c/feedback'),
        meta: { title: '问题反馈', requireAuth: true },
    },
    {
        path: '/rent/v2/c2c/receiveCoupon',
        name: 'receiveCoupon',
        component: () => import('@/pages/c2c/receiveCoupon'),
        meta: { title: '领券', requireAuth: true },
    },
    {
        path: '/rent/v2/c2c/result',
        name: 'result',
        component: () => import('@/pages/c2c/receiveResult'),
        meta: { title: '领取结果', requireAuth: true },
    },
    {
        path: '/rent/v2/c2c/introduce',
        name: 'c2cIntroduce',
        component: () => import('@/pages/c2c/introduce'),
        meta: { title: '房车推客', requireAuth: true },
    },
    {
        path: '/rent/v2/c2c/join',
        name: 'c2cJoin',
        component: () => import('@/pages/c2c/join'),
        meta: { title: '开通推客', requireAuth: true },
    },
    {
        path: '/rent/v2/c2c/invite',
        name: 'c2cInvite',
        component: () => import('@/pages/c2c/invite'),
        meta: { title: '邀请新用户', requireAuth: true },
    },
    {
        path: '/rent/v2/c2c/withdraw',
        name: 'withdraw',
        component: () => import('@/pages/c2c/withdraw'),
        meta: { title: '申请提现', requireAuth: true },
    },
    {
        path: '/rent/v2/c2c/auth',
        name: 'auth',
        component: () => import('@/pages/c2c/auth'),
        meta: {title: '实名认证', requireAuth: true},
    },
    {
        path: '/rent/v2/c2c/withdrawResult',
        name: 'withdrawResult',
        component: () => import('@/pages/c2c/withdrawResult'),
        meta: {title: '提现成功', requireAuth: true},
    },
    {
        path: '/rent/v2/c2c/sendTool',
        name: 'sendTool',
        component: () => import('@/pages/c2c/sendTool'),
        meta: {title: '发券工具', requireAuth: true},
    },
    {
        path: '/rent/v2/c2c/twRegister',
        name: 'twRegister',
        component: () => import('@/pages/c2c/twRegister'),
        meta: {title: '', requireAuth: true},
    },
    {
        path: '/rent/v2/c2c/registerResult',
        name: 'c2cRegisterResult',
        component: () => import('@/pages/c2c/registerResult'),
        meta: {title: '房车推客报名登记', requireAuth: true},
    },
]



// WEBPACK FOOTER //
// ./src/pages/c2c/c2c.js